import { type FunctionComponent } from "react";

import renoWalkLogo from "images/Common/RenoWalk_logo.png";

import { type IBTIconProps } from "../BTIcon.types";

export const BTIconDeprecatedRenoWalk: FunctionComponent<IBTIconProps> = (baseProps) => {
    return (
        <img alt="" src={renoWalkLogo} style={baseProps.style} className={baseProps.className} />
    );
};
